module.exports = __webpack_public_path__ + "static/media/P.a94f3d12.svg";